var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "institution-edit" } },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.modal.title, "footer-hide": "", width: 500 },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c(
            "IForm",
            {
              key: _vm.modal.visible,
              style: {
                "max-height": "800px",
                "min-width": "500px",
                "overflow-y": "auto",
              },
              attrs: {
                model: _vm.edit,
                elem: _vm.institutionElem,
                rules: _vm.institutionRule,
                loading: _vm.loading.form,
                "btn-loading": _vm.loading.btn,
                width: 830,
                "label-width": 100,
                button: "",
                "button-text": "取消",
              },
              on: {
                "on-submit": _vm.handleSubmit,
                "on-click": function ($event) {
                  _vm.modal.visible = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "extend" }, slot: "extend" },
                [
                  !this.edit.id && _vm.userType <= 3
                    ? _c(
                        "FormItem",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            "label-width": 80,
                            label: "省份",
                            prop: "provinceCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.changeProvince },
                              model: {
                                value: _vm.edit.provinceCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "provinceCode", $$v)
                                },
                                expression: "edit.provinceCode",
                              },
                            },
                            _vm._l(_vm.provinceList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !this.edit.id && (_vm.edit.provinceCode || _vm.userType == 4)
                    ? _c(
                        "FormItem",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            "label-width": 80,
                            label: "城市",
                            prop: "cityCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.changeCity },
                              model: {
                                value: _vm.edit.cityCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "cityCode", $$v)
                                },
                                expression: "edit.cityCode",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !this.edit.id && (_vm.edit.cityCode || _vm.userType == 5)
                    ? _c(
                        "FormItem",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            "label-width": 80,
                            label: "区",
                            prop: "areaCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.changeArea },
                              model: {
                                value: _vm.edit.areaCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "areaCode", $$v)
                                },
                                expression: "edit.areaCode",
                              },
                            },
                            _vm._l(_vm.areaList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !this.edit.id && _vm.edit.areaCode
                    ? _c(
                        "FormItem",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            "label-width": 80,
                            label: "街道",
                            prop: "streetCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.streetCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "streetCode", $$v)
                                },
                                expression: "edit.streetCode",
                              },
                            },
                            _vm._l(_vm.streetList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 100,
                        label: "模版",
                        prop: "analysisTemplateId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "468px" },
                          attrs: {
                            placeholder: "请选择模版",
                            clearable: "",
                            filterable: "",
                            size: "small",
                            transfer: "true",
                            "popper-append-to-body": false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleTemplateMethodChange($event)
                            },
                          },
                          model: {
                            value: _vm.edit.analysisTemplateName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.edit,
                                "analysisTemplateName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "edit.analysisTemplateName",
                          },
                        },
                        _vm._l(_vm.analysisList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            staticStyle: { width: "468px" },
                            attrs: { label: item.name, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 100,
                        label: "分析模版",
                        prop: "targetTemplateId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "468px" },
                          attrs: {
                            placeholder: "请选择目标分析模版",
                            clearable: "",
                            filterable: "",
                            size: "small",
                            transfer: "true",
                            "popper-append-to-body": false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleTargetTemplateMethodChange(
                                $event
                              )
                            },
                          },
                          model: {
                            value: _vm.edit.targetTemplateName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.edit,
                                "targetTemplateName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "edit.targetTemplateName",
                          },
                        },
                        _vm._l(_vm.analysisList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            staticStyle: { width: "468px" },
                            attrs: { label: item.name, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 100,
                        label: "客户套餐",
                        prop: "communityId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "468px" },
                          attrs: {
                            placeholder: "请选择客户套餐",
                            clearable: "",
                            filterable: "",
                            size: "small",
                            transfer: "true",
                            "popper-append-to-body": false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleRemoteMethodChange($event)
                            },
                          },
                          model: {
                            value: _vm.edit.collectionLocationName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.edit,
                                "collectionLocationName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "edit.collectionLocationName",
                          },
                        },
                        _vm._l(_vm.communitysList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            staticStyle: { width: "468px" },
                            attrs: {
                              label: item.collectionLocationName,
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.jindaShow
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 100,
                            label: "金达机构",
                            prop: "jindaId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "468px" },
                              attrs: {
                                placeholder: "请选择金达机构",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleJindaMethodChange($event)
                                },
                              },
                              model: {
                                value: _vm.edit.jindaName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "jindaName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "edit.jindaName",
                              },
                            },
                            _vm._l(_vm.jindaList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "468px" },
                                attrs: { label: item.name, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.capShow
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 100,
                            label: "账号密码",
                            prop: "capId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "468px" },
                              attrs: {
                                placeholder: "请选择账号密码",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleAccountPasswordMethodChange(
                                    $event
                                  )
                                },
                              },
                              model: {
                                value: _vm.edit.capName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "capName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "edit.capName",
                              },
                            },
                            _vm._l(_vm.accountPasswordList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "468px" },
                                attrs: { label: item.name, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.organShow
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 100,
                            label: "社康机构",
                            prop: "organId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "468px" },
                              attrs: {
                                placeholder: "请选择社康机构",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleOrgansMethodChange($event)
                                },
                              },
                              model: {
                                value: _vm.edit.organName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "organName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "edit.organName",
                              },
                            },
                            _vm._l(_vm.organList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "468px" },
                                attrs: { label: item.name, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }